import { c as _c } from "react/compiler-runtime";
import { FunctionComponent } from "react";
import { NOT_FOUND_IMAGE_SOURCES } from "../../assets";
import styles from "./not-found-visual.module.scss";
const NotFoundVisual: FunctionComponent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <picture className={styles.picture}><source media="(min-width: 1920px)" srcSet={NOT_FOUND_IMAGE_SOURCES.desktopXl} /><source media="(min-width: 1024px)" srcSet={NOT_FOUND_IMAGE_SOURCES.desktop} /><source media="(min-width: 834px)" srcSet={NOT_FOUND_IMAGE_SOURCES.tablet} /><img className={styles.image} src={NOT_FOUND_IMAGE_SOURCES.mobile} alt="" aria-hidden={true} /></picture>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default NotFoundVisual;